export const setView = async () => {
  const breedId = document.querySelector('.breed-detail__info').getAttribute('data-breed-id');
  const urlView = `/api/breed/${breedId}/view/`;
  const res = await fetch(urlView, {
    method: 'PUT',
  });
  const data = await res.json();

  if (!!data) {
    document.querySelector('.views-count').textContent = data;
  }
};
